module.exports = __webpack_public_path__ + "static/media/epan.5cca3a6a.png";